export enum GiftFundCodesEnum {
  Birthday = 'BG',
  Child = 'GG',
  Family = 'FG',
  Center = 'PG',
}
